import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";


const COLORS = ["#F564A9","#483AA0","#FF9F00"];

const ScopePieChart = ({report}) => {
  const data = [
    { name: "Scope 1", value: report.scope1/1000 },
    { name: "Scope 2 Market", value: report.scope2MarketBased/1000 },
    { name: "Scope 2 Location", value: report.scope2LocationBased/1000 },
  ];
  return (
    <div className="bg-white p-4 shadow-md rounded-lg w-full">
      <h2 className="text-lg font-bold mb-3">Carbon Emissions by Scope</h2>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            label
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ScopePieChart;
